/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectSpecificBillingInfoParam
 */
export interface ProjectSpecificBillingInfoParam {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectSpecificBillingInfoParam
     */
    projectBillingContacts: Array<string>;
}

/**
 * Check if a given object implements the ProjectSpecificBillingInfoParam interface.
 */
export function instanceOfProjectSpecificBillingInfoParam(value: object): value is ProjectSpecificBillingInfoParam {
    if (!('projectBillingContacts' in value) || value['projectBillingContacts'] === undefined) return false;
    return true;
}

export function ProjectSpecificBillingInfoParamFromJSON(json: any): ProjectSpecificBillingInfoParam {
    return ProjectSpecificBillingInfoParamFromJSONTyped(json, false);
}

export function ProjectSpecificBillingInfoParamFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectSpecificBillingInfoParam {
    if (json == null) {
        return json;
    }
    return {
        
        'projectBillingContacts': json['projectBillingContacts'],
    };
}

export function ProjectSpecificBillingInfoParamToJSON(value?: ProjectSpecificBillingInfoParam | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectBillingContacts': value['projectBillingContacts'],
    };
}

